import type * as React from 'react';
import {
  type Dispatch,
  type FC,
  type SetStateAction,
  useEffect,
  useState,
} from 'react';

import ArrowIosDown from '@crehana/icons/outline/ArrowIosDown';
import ArrowIosUp from '@crehana/icons/outline/ArrowIosUp';
import { useMediaQuery } from '@crehana/react-hooks';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Collapse } from '@crehana/ui';

import useCheckoutCtx from '@/views/B2BCheckout/hooks/useCheckoutCtx';

import LicenceCounter from './LicenceCounter';

interface TotalBarProps {
  total: string;
  className?: string;
  setOpen?: Dispatch<SetStateAction<boolean>>;
  open?: boolean;
}

const TotalBar: FC<React.PropsWithChildren<TotalBarProps>> = ({
  total,
  className,
  setOpen,
  open,
}) => (
  <div className={`p-24 bg-primary-lighter-56 ${className}`}>
    <div className="flex justify-between items-center w-full">
      <p className="font-subtitle3">Total anual</p>
      <div className="flex items-center">
        <p className="font-button">{total}</p>
        {setOpen && (
          <button
            type="button"
            onClick={() => {
              setOpen(state => !state);
            }}
            className="ml-16 w-20 h-20"
          >
            {open ? <ArrowIosDown size={20} /> : <ArrowIosUp size={20} />}
          </button>
        )}
      </div>
    </div>
  </div>
);

const PurchaseSummary = () => {
  const { matches: isMd } = useMediaQuery('md');
  const [open, setOpen] = useState(!!isMd);
  const {
    state: { licences, totalPrice },
    pricePerSeat,
    productName,
    currency,
  } = useCheckoutCtx();

  useEffect(() => {
    if (isMd) {
      setOpen(true);
    }
  }, [isMd]);

  return (
    <div className="fixed md:static bottom-0 right-0 left-0 z-1 bg-white">
      <Collapse
        className="p-24 md:p-0 bg-gray-lighter flex flex-col"
        open={open}
      >
        <LicenceCounter />
        <div className="md:bg-white rounded-5 md:shadow-dropdown overflow-hidden md:mb-40 w-full">
          <div className="md:p-24">
            <p className="font-subtitle3 mb-24">Resumen de compra</p>
            <p className="font-subtitle3 text-primary-main mb-12">
              {productName}
            </p>
            <div className="pb-12 border-b border-solid border-gray-light mb-24">
              <div className="flex justify-between items-center mb-12">
                <p className="font-body4 text-gray-dark">
                  Precio anual por usuario
                </p>
                <p className="font-body4">
                  {currency} {pricePerSeat}
                </p>
              </div>
              <div className="flex justify-between items-center mb-12">
                <p className="font-body4 text-gray-dark">Cantidad de Usuario</p>
                <p className="font-body4">x {licences}</p>
              </div>
              <div className="flex justify-between items-center mb-12">
                <p className="font-body4 text-gray-dark">
                  Precio por total de usuarios
                </p>
                <p className="font-body4">
                  {currency} {totalPrice}
                </p>
              </div>
            </div>
            <p className="font-subtitle3 mb-12">Pago anual</p>
            <div className="flex justify-between items-center">
              <p className="font-body4 text-gray-dark">Total anual</p>
              <p className="font-body4">
                {currency} {totalPrice}
              </p>
            </div>
          </div>
          <TotalBar
            total={`${currency} ${totalPrice}`}
            className="hidden md:flex"
          />
        </div>
      </Collapse>
      <TotalBar
        total={`${currency} ${totalPrice}`}
        className="flex md:hidden"
        setOpen={setOpen}
        open={open}
      />
    </div>
  );
};

export default PurchaseSummary;
